export const userIdSelector = state => state.auth && state.auth.user ? state.auth.user.user_id : -1;
export const userGatesSelector = state => state.auth && state.auth.gates;